import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericDocTemplateService } from './generic-doc-template.service';

@Injectable({
  providedIn: 'root'
})
export class SalesInvoiceTemplateService extends GenericDocTemplateService {

  constructor(http: HttpClient) {
    super(http, 'internal-sales-invoices');
  }
}
